import React from 'react';
import { Skeleton } from '../Skeleton';

const SessionCardLoader = () => {
  return (
    <>
      <div className="w-100 float-start ssnCardV1Box shadow rounded-3 overflow-hidden position-relative bg-white">
        <div className="w-100 float-start ssnCardV1BoxPic cursorPointer overflow-hidden position-relative d-flex justify-content-center align-items-center">
          <Skeleton
            variant="rectangular"
            width="100%"
            height="100%"
            className="object-fit-cover float-start position-absolute top-0 start-0 "
          />
        </div>
        <div className="w-100 float-start ssnCrdV1Btm p-3  ps-0 ps-lg-0">
          <div className="crdV1topPart d-flex align-items-center justify-content-between position-relative ps-3 mb-2 ps-lg-4">
            <span className="crdV1topPartGraph position-absolute start-0 top-50 translate-middle-y"></span>
            <span className="fs-4 text-black crdV1Speclty d-flex">
              {/* <i className="flaticon-customer-service-headset text-primary fs-3 me-3"></i> */}
              <Skeleton variant="circular" width={20} height={20} className="me-3" />
              <Skeleton variant="text" width={100} height={20} />
            </span>
            <div className="d-flex align-items-center gap-2">
              <a href="javascript:void(0)" className="cardV1DotsMenu text-black">
                <Skeleton variant="circular" width={20} height={20} />
              </a>
            </div>
          </div>
          <div className="w-100 float-start d-flex text-start cardV1Topic ps-3 ps-lg-4 mb-2">
            <div className="cardV1TopicContent cursorPointer position-relative w-100">
              <h2
                className={`text-black fs-16 fw-medium line-clamp-3 gtm_cl_SessionCardV1 lh-base`}
              >
                <Skeleton variant="text" width="80%" height={20} />
              </h2>
            </div>
          </div>
          <div className={`w-100 float-start cmncrdV1Doctor text-start ps-3 ps-md-4 cursorPointer`}>
            <div className="crdV1DoctorBox text-start w-auto float-start">
              <div className="w-100 rounded crdV1DoctorBoxIn d-flex justify-content-between align-items-center py-2 px-3 border border-light">
                <Skeleton variant="circular" width={50} height={50} />
                <div className="crdV1DoctorContent ps-4 flex-1">
                  <Skeleton variant="text" width={120} height={20} />
                  <Skeleton variant="text" width={90} height={15} />
                </div>
              </div>
            </div>
          </div>
          <div className="w-100 float-start cardV1Ftr d-flex align-items-center justify-content-between ps-3 ps-lg-4 mt-2">
            <div
              className={`cardV1FtrBtn d-inline-block overflow-hidden py-3 px-2 fs-4 fw-medium rippleEffect rounded cursorPointer gtm_cl_SessionCardV1_getRecording`}
            >
              <Skeleton variant="rounded" width={100} height={30} />
            </div>
            <div
              className={`cardV1FtrBtn d-inline-block overflow-hidden py-3 px-2 fs-4 fw-medium rippleEffect rounded cursorPointer gtm_cl_SessionCardV1_attend_ViewSession_Join_viewCase_Button`}
            >
              <span className={`gtm_cl_SessionCardV1_attendButton d-flex align-items-center fs-4`}>
                <Skeleton variant="rounded" width={100} height={30} />
              </span>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SessionCardLoader;
